/*
 *
 * ReportHeader actions
 *
 */

import {
  GET_MEDITIONS_FAILED,
  GET_MEDITIONS_SUCCESS,
  GET_MEDITIONS_WATCHER,
  MEDITIONS_ACTIONS_FAILED,
  MEDITIONS_ACTIONS_SUCCESS,
  MEDITIONS_ACTIONS_WATCHER,
  OFFICIALIZE_MEDITIONS_FAILED,
  OFFICIALIZE_MEDITIONS_SUCCESS,
  OFFICIALIZE_MEDITIONS_WATCHER,
  SET_CURRENT_MEDITION,
} from "./constants"

export function getMeditionsWatcher(payload) {
  return {
    type: GET_MEDITIONS_WATCHER,
    payload,
  }
}

export function getMeditionsSuccess(payload) {
  return {
    type: GET_MEDITIONS_SUCCESS,
    payload,
  }
}

export function getMeditionsFailed() {
  return { type: GET_MEDITIONS_FAILED }
}

// officialize
export function officializeWatcher(payload) {
  return {
    type: OFFICIALIZE_MEDITIONS_WATCHER,
    payload,
  }
}

export function officializeSuccess(payload) {
  return {
    type: OFFICIALIZE_MEDITIONS_SUCCESS,
    payload,
  }
}

export function officializeFailed() {
  return { type: OFFICIALIZE_MEDITIONS_FAILED }
}

export function setCurrentMedition(payload) {
  return {
    type: SET_CURRENT_MEDITION,
    payload,
  }
}

export function getMeditionsAvailableActionsWatcher(payload) {
  return {
    type: MEDITIONS_ACTIONS_WATCHER,
    payload,
  }
}

export function getMeditionsAvailableActionsSuccess(payload) {
  return {
    type: MEDITIONS_ACTIONS_SUCCESS,
    payload,
  }
}

export function getMeditionsAvailableActionsFailed() {
  return { type: MEDITIONS_ACTIONS_FAILED }
}
